import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

// ORGANIZATION
const getOrganizationUsers = (organizationId) => axiosInstance.get(`${SERVICES.ORGANIZATION}/${organizationId}/users`)

//SMS
const createSenderSMS = (organizationId, data) =>
  axiosInstance.post(`${SERVICES.SENDER}/${organizationId}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })

const getSenders = (organizationId, params) => axiosInstance.get(`${SERVICES.SENDER}/${organizationId}`, params)

const getDownloadDocSender = (organizationId, fileName) =>
  axiosInstance.get(`${SERVICES.SENDER}/${organizationId}/download/${fileName}`, { responseType: 'blob' })

const getSendersByOrganizationUserId = (organizationId) => axiosInstance.get(`${SERVICES.SENDER}/${organizationId}/currentusersenders`)

const deleteSender = (organizationId, id) => axiosInstance.delete(`${SERVICES.SENDER}/${organizationId}/${id}`)

const approveorreject = (organizationId, body) => axiosInstance.post(`${SERVICES.SENDER}/${organizationId}/approveorreject`, body)

const getUsersSenderSms = (organizationId, organizationSenderId) =>
  axiosInstance.get(`${SERVICES.SENDER}/${organizationId}/${organizationSenderId}/users`)

const addUserSenderSms = (organizationId, organizationSenderId, body) =>
  axiosInstance.post(`${SERVICES.SENDER}/${organizationId}/${organizationSenderId}/users`, body)

const removeUserSenderSms = (organizationId, organizationSenderId, userSenderId) =>
  axiosInstance.delete(`${SERVICES.SENDER}/${organizationId}/${organizationSenderId}/users/${userSenderId}`)

//DOMAIN
const createSenderDomain = (organizationId, body) => axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}`, body)

const getSendersDomain = (organizationId, params) => axiosInstance.get(`${SERVICES.SENDER_DOMAIN}/${organizationId}`, params)
const getSendersDomainByOrganizationUserId = (organizationId) => axiosInstance.get(`${SERVICES.SENDER_DOMAIN}/${organizationId}/currentusersenders`)

const deleteSenderDomain = (organizationId, id) => axiosInstance.delete(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${id}`)
const approveorrefuse = (organizationId, body) => axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}/approveorrefuse`, body)
const configureSenderDomain = (organizationId, senderRequestId, body) =>
  axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${senderRequestId}/reply`, body)

const submitDnsValidate = (organizationId, body) => axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}/sender/dns/validate`, body)

const authenticateSenderDomain = (organizationId, senderRequestId, body) =>
  axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${senderRequestId}/authenticateorunauthenticate`, body)

const getUsersSenderDomain = (organizationId, organizationSenderDomainId) =>
  axiosInstance.get(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${organizationSenderDomainId}/users`)
const addUserSenderDomain = (organizationId, organizationSenderDomainId, body) =>
  axiosInstance.post(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${organizationSenderDomainId}/users`, body)
const removeUserSenderDomain = (organizationId, organizationSenderDomainId, userSenderDomainId) =>
  axiosInstance.delete(`${SERVICES.SENDER_DOMAIN}/${organizationId}/${organizationSenderDomainId}/users/${userSenderDomainId}`)

export default {
  getOrganizationUsers,

  //SMS
  createSenderSMS,
  getSenders,
  approveorreject,
  deleteSender,
  getDownloadDocSender,
  getUsersSenderSms,
  removeUserSenderSms,
  addUserSenderSms,
  getSendersByOrganizationUserId,

  //DOMAIN
  createSenderDomain,
  getSendersDomain,
  deleteSenderDomain,
  approveorrefuse,
  getUsersSenderDomain,
  addUserSenderDomain,
  removeUserSenderDomain,
  configureSenderDomain,
  submitDnsValidate,
  authenticateSenderDomain,
  getSendersDomainByOrganizationUserId,
}
